// 前後端共用的類別
//import { Logger, setLevel } from "loglevel";
import { NativeDateAdapter } from "@angular/material/core";
import {
  CR,
  idNameItem,
  IOpenaiCompletionOption,
  IopenWin,
  jkRestReturn,
  kbar,
  keyValue2SqlWhereOption,
  OpenWinLoadOption,
} from "./jkInterface";

export let logger = console;


export function subscribeError(error: any) {
  /*if (error.message.includes('host not found')) {
    alert('Host 不存在 或 無法連線');
  } else {
    alert('subscribe 錯誤:' + error.message);
  }*/
  alert('subscribe 錯誤:' + error.message);
};

export const mp3_pristine: string = '/assets/audio/' + 'pristine.mp3';

export function newOpenwinLoadOption(
  mainTable: string,
  item: string,
  type: string,
  params: any[],
  list: any[]
): OpenWinLoadOption {
  let r: OpenWinLoadOption = {
    mainTable: mainTable,
    item: item,
    type: type,
    params: params,
    list: list,
  };
  return r;
}

export function notify(msg: string, _type: string, _delay: number) {
  jkAlert(msg);
}
/**
 *
 * @param msg1
 * @param type error,E,W
 * @returns
 */
export function jkAlert(msg1: string, type?: string): boolean {
  //page.showAlert(msg1);
  if ((type === 'error') || (type === 'E')) {
    alert(msg1);
    throw new Error(msg1);// 停止執行
  }
  //alert(msg1);
  return confirm(msg1);
  //await confirm("<i>" + msg1 + "</i>", type)
}

export function jkError(msg1: string, errors: any) {
  // TODO
  let msg = msg1 + JSON.stringify(errors);
  alert(msg1);
  throw new Error(msg1);// 停止執行

}

export function searchById(appPages: AppPage[], programId: string): AppPage | undefined {
  if (!appPages) {
    alert('searchById appPages is undefined');
    return undefined;
  }
  //let result:AppPage = {id:'',title:'',url:'',icon:''};
  let result = appPages.find((item: AppPage) => {
    if (item.id.toLowerCase() === programId.toLowerCase().trim()) {
      return item;
      // return result;
    } else {
      return undefined;
    }
  });
  return result;
}

//[class 開始]----------------------------------------------

export class idNameItemService implements idNameItem {
  id: string;
  name: string;
  get idName(): string {
    return this.id + " " + this.name;
  }
  /*
  set idName(xIdName: string)? {
  }*/
  get nameId(): string {
    return this.name + " " + this.id;
  }
  /*set nameId(xNameId: string) {
  }*/
  icon?: string;
  constructor(xId: string, xName: string, xIcon?: string) {
    this.id = xId;
    this.name = xName;
    this.icon = xIcon;
  }
}

export class jkRestReturnClass implements jkRestReturn {
  result: boolean;
  message: string;
  data: string;
  obj: any;
  request: any;
  rowsAffected: number;
  log: string = "";
  errorLog: string = "";
  errorCode: number = 0;
  errorMessage: string = "";
  parent: any; // 父 jkRestReturn 也可傳回
  constructor() {
    this.result = false;
    this.message = "";
    this.data = "";
    this.rowsAffected = 0;
  }
  ok(): void {
    this.result = true;
  }
  getResultError(): string {
    return this.errorLog;
  }
  clear(bool: boolean = false): void {
    // 不clear parent
    this.result = bool;
    this.message = "";
    this.data = "";
    this.rowsAffected = 0;
    this.log = "";
    this.errorLog = "";
    this.errorCode = 0;
    this.errorMessage = "";
    this.obj = {};
  }
  clearAll() {
    this.clear();
    this.parent = {};
  }
  /* 只用addResultError
  error(errorMsg: string): void {
      this.clear()
      //this.result = false;
      this.message = errorMsg;
  }*/
  stringify(): string {
    const obj: any = {
      result: this.result,
      message: this.message,
      data: this.data,
      obj: this.obj,
      rowsAffected: this.rowsAffected,
    };
    return obj.stringify();
  }
  AddResult(xLog: string) {
    this.addResult(xLog);
  }
  addResult(xLog: string) {
    this.log = this.log + CR + xLog;
  }
  getResult(): string {
    return this.log;
  }
  addResultError(xLog: string, isLogger: boolean = false): string {
    this.result = false;
    let msg: string = jkBaseLib.nowDateTime() + " " + xLog;
    this.errorLog = this.errorLog + CR + "XXX " + msg;
    if (isLogger) {
      console.error(msg);
    }
    return msg;
  }
  addResultWarning(xLog: string): string {
    let msg: string = jkBaseLib.nowDateTime() + " " + xLog;
    this.errorLog = this.errorLog + CR + "WWW " + msg;
    return msg;
  }
  mergeLog(from: jkRestReturn) {
    if (from.getResult() !== "") {
      this.addResult(from.getResult());
    }
    if (from.message !== "") {
      this.message = this.message + CR + from.message;
    }
    if (from.getResultError() !== "") {
      this.errorLog = this.errorLog + CR + from.getResultError();
    }
  }
  assign(from: jkRestReturn) {
    this.result = from.result ?? false;
    this.message = from.message ?? '';
    this.data = from.data ?? '';
    this.obj = from.obj ?? null;
    this.rowsAffected = from.rowsAffected ?? 0;
    this.log = from.log ?? '';
    this.errorLog = from.errorLog ?? '';
    this.errorCode = from.errorCode ?? 0;
    this.errorMessage = from.errorMessage ?? '';
  }
  getObj(n: number): any {
    TODO:
    if (Array.isArray(this.obj)) {
      if (n < this.obj.length) {
        return this.obj[n];
      } else {
        this.addResultError("getObj(n) 超出array範圍.");
        return undefined;
      }
    } else {
      this.addResultError("getObj(n) 不是array.");
      return undefined;
    }
  }
}

export class AppPage {
  title: string = '';
  url?: string = '';
  icon?: string = '';
  id: string = '';
  isCheckPower: boolean = true;
  checked?: boolean = false;
  caption?: string = '';
  hint?: string = '';
  items?: AppPage[] = [];
  level?: number = 0;
  expandable?: boolean = false;
}

export class List<T> {
  private items: Array<T>;

  constructor() {
    this.items = [];
  }

  size(): number {
    return this.items.length;
  }

  add(value: T): void {
    this.items.push(value);
  }

  get(index: number): T {
    return this.items[index];
  }
}

export function iif(b: boolean, xTrue: any, xFalse: any): any {
  if (b) return xTrue;
  else return xFalse;
}

/** @param prompt prompt: 問題內容。
 * @param ret
 * @param n    整數，表示生成的候選項數量。
 * @param max_tokens 一個整數，表示生成的文本的最大令牌數。
 * @param temperature 一個浮點數，表示生成文本的隨機性。值越高，生成的文本就越隨機。
 * @param top_p 一個浮點數，表示只考慮概率最高的一部分候選項，以避免生成不相關的或者無意義的文本。
 * 一個字符串，表示生成文本的終止條件。
 * @param frequency_penalty 一個浮點數，表示鼓勵生成更不常見的文本。
 * @param presence_penalty 一個浮點數，表示鼓勵生成更不常見的文本。
 */
export class XXXopenaiCompletionOption {
  /*n: number; // 1 回答的候選項數量。一個整數，表示生成的候選項數量。
  model: string = "text-davinci-003";
  prompt: string;
  temperature: number; // 0.3 or 0.6
  max_tokens: number; // 100 max:4096
  top_p: number; // 1.0
  frequency_penalty: number; // 0.0
  presence_penalty: number; // 0.0,*/
  constructor() {
    // this.setdefault(this);
  }
  setdefault(o: IOpenaiCompletionOption) {
    if (!o) {
      o = { n: 1, model: "", systemPrompt: "", prompt: "", temperature: 0.2 };
    }
    o.n = 1;
    o.model = ''; //this.modelList[0].id;
    o.prompt = "";
    o.temperature = 0.4; // 0.9
    o.max_tokens = 500;
    o.top_p = 1.0;
    o.frequency_penalty = 0.0;
    o.presence_penalty = 0.0;
  }
  /*
  modelList: idNameItem[] = [
    { id: "text-davinci-003", name: "穩定版text-davinci-003" },
    { id: "gpt-3.5-turbo", name: "測試版gpt-3.5-turbo" },
    { id: "gpt-4", name: "測試版gpt-4.等待中" },
    { id: "gpt-4-0314", name: "測試版gpt-4-0314" },
    { id: "text-davinci-001", name: "text-davinci-001" },
    { id: "text-davinci-002", name: "text-davinci-002" },
    { id: "text-davinci-insert-001", name: "text-davinci-insert-001" },
    { id: "text-davinci-insert-002", name: "text-davinci-insert-002" },
    { id: "text-davinci-edit-001", name: "text-davinci-edit-001" },
    { id: "text-embedding-ada-002", name: "text-embedding-ada-002,插入詞" },
    { id: "text-ada-001", name: "text-ada-001" },
    {
      id: "text-curie-001",
      name: "text-curie-001,Very capable, but faster and lower cost than Davinci.",
    },
    {
      id: "text-babbage-001",
      name: "text-babbage-001,能夠完成簡單的任務,快速低成本.",
    },
    { id: "curie-instruct-beta", name: "curie-instruct-beta" },
    { id: "babbage-code-search-text", name: "babbage-code-search-text" },
    { id: "babbage-similarity", name: "babbage-similarity" },
    { id: "code-davinci-002", name: "code-davinci-002" },
    {
      id: "code-search-babbage-text-001",
      name: "code-search-babbage-text-001,dev,",
    },
    { id: "code-cushman-001", name: "code-cushman-001" },
    { id: "code-davinci-edit-001", name: "code-davinci-edit-001" },
    { id: "davinci-instruct-beta", name: "davinci-instruct-beta" },
    { id: "if-davinci-v2", name: "if-davinci-v2" },
    { id: "if-curie-v2", name: "if-curie-v2" },
    { id: "audio-transcribe-deprecated", name: "audio-transcribe-deprecated" },
  ];
  helper: idNameItem[] = [
    {
      id: "ada",
      name: "Ada(NT$0.012148) 通常是最快的模型，可以執行解析文本、地址更正和不需要太多細微差別的某些分類任務等任務。 Ada 的性能通常可以通過提供更多上下文來提高。  擅長：解析文本、簡單分類、地址修正、關鍵詞",
    },
    {
      id: "Babbage",
      name: "Babbage(NT$0.015185)  可以執行簡單的任務，例如簡單的分類。 在語義搜索方面，它也非常有能力對文檔與搜索查詢的匹配程度進行評估。  擅長：簡單分類、語義搜索",
    },
    {
      id: "curie",
      name: "curie(NT$0.060738)  居里非常強大，但速度非常快。 雖然 Davinci 在分析複雜文本方面更強大，但 Curie 能夠勝任許多細微的任務，例如情感分類和摘要。 Curie 還非常擅長回答問題和執行問答以及作為通用服務聊天機器人。  擅長：語言翻譯、複雜分類、文本情感、摘要",
    },
    {
      id: "davinci",
      name: "Davinci(NT$0.607380)  是最有能力的模型系列，可以執行其他模型可以執行的任何任務，而且通常只需要很少的指令。 對於需要對內容有大量理解的應用程序，例如針對特定受眾的摘要和創意內容生成，Davinci 將產生最佳結果。 這些增加的功能需要更多的計算資源，因此 Davinci 每次 API 調用的成本更高，並且不如其他模型快。 Davinci 的另一個亮點是理解文本的意圖。 達芬奇擅長解決多種邏輯問題和解釋人物的動機。 達芬奇已經能夠解決一些涉及因果關係的最具挑戰性的人工智能問題。  擅長：複雜的意圖、因果、為聽眾總結",
    },
  ];*/
}
/**
 *
GPT-3	一系列可以了解並產生自然語言的模型。

Ada NT$0.012148 Ada 通常是最快的模型，可以執行解析文本、地址更正和不需要太多細微差別的某些分類任務等任務。 Ada 的性能通常可以通過提供更多上下文來提高。
  擅長：解析文本、簡單分類、地址修正、關鍵詞

Babbage NT$0.015185 Babbage 可以執行簡單的任務，例如簡單的分類。 在語義搜索方面，它也非常有能力對文檔與搜索查詢的匹配程度進行排名。
    擅長：適度分類、語義搜索分類
Curie NT$0.060738  居里非常強大，但速度非常快。 雖然 Davinci 在分析複雜文本方面更強大，但 Curie 能夠勝任許多細微的任務，例如情感分類和摘要。 Curie 還非常擅長回答問題和執行問答以及作為通用服務聊天機器人。
    擅長：語言翻譯、複雜分類、文本情感、摘要
Davinci NT$0.607380 Davinci 是最有能力的模型系列，可以執行其他模型可以執行的任何任務，而且通常只需要很少的指令。 對於需要對內容有大量理解的應用程序，例如針對特定受眾的摘要和創意內容生成，Davinci 將產生最佳結果。 這些增加的功能需要更多的計算資源，因此 Davinci 每次 API 調用的成本更高，並且不如其他模型快。
  Davinci 的另一個亮點是理解文本的意圖。 達芬奇擅長解決多種邏輯問題和解釋人物的動機。 達芬奇已經能夠解決一些涉及因果關係的最具挑戰性的人工智能問題。
  擅長：複雜的意圖、因果、為聽眾總結
 */

export class jkBaseLibClass {
  CR: string = "\r\n";
  //logger: Logger;
  jkRet: jkRestReturn;
  dtBegin: Date;
  logTime: Date;
  constructor() {
    this.jkRet = new jkRestReturnClass();
    this.dtBegin = new Date();
    this.logTime = new Date();
  }
  stringList2IdNameItem(arr: string[]): idNameItem[] {
    let result: idNameItem[] = [];
    for (let i = 0; i < arr.length; i++) {
      let obj: idNameItem = { id: arr[i], name: arr[i] };
      result.push(obj);
    }
    return result;
  }
  string2IdNameItem(data: string, sperator: string): idNameItem[] {
    //const items:idNameItem[] = data.trim().split(/\s+/).map(item => ({
    const items: idNameItem[] = data.trim().split(sperator).map(item => ({
      id: item,
      name: item
    }));

    //console.log(JSON.stringify(items, null, 2));
    return items;
  }
  /**
   * 字串格式 a:nameA,b:nameB 或 a:nameA b:nameB 或 a:nameA,b:nameB
   * 轉成 idNameItem[] 格式 例如: [{id:'a',name:'nameA'},{id:'b',name:'nameB'}]
   * @param data
   * @param sperator
   * @returns
   */
  colonString2IdNameItem(data: string, sperator: string = ', '): idNameItem[] {
    //const items:idNameItem[] = data.trim().split(/\s+/).map(item => ({
    data = this.swapStr(data, '\n', ' ');
    const items: idNameItem[] = data.trim().split(sperator).map(item => {
      const [id, name] = item.split(':');
      if (!name || !id)
        return { id: '', name: '' };
      return { id: id.trim(), name: name.trim() };
    });
    //console.log(JSON.stringify(items, null, 2));
    return items;
  }

  idNameItem2String(arr: idNameItem[]): string[] {
    let result: string[] = [];
    for (let i = 0; i < arr.length; i++) {
      result.push(arr[i].id);
    }
    return result;
  }
  /**
   * id 逗點分隔
   * @param arr
   * @returns
   */
  idNameItem2String2(arr: idNameItem[]): string {
    let result: string = "";
    for (let i = 0; i < arr.length; i++) {
      result = result + iif(result === "", "", ",") + arr[i].id;
    }
    return result;
  }
  nowDate(): string {
    const now = new Date();
    let mStr = now.getFullYear().toString();
    mStr = mStr + this.zeroAtFirst(now.getMonth() + 1, 2);
    mStr = mStr + this.zeroAtFirst(now.getDate(), 2);
    return mStr;
  }
  formatDateTime(date: Date): string {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }

  nowDate10(dateSign: string): string {
    let now = new Date();
    let mStr = now.getFullYear().toString();
    mStr = mStr + dateSign + this.zeroAtFirst(now.getMonth() + 1, 2);
    mStr = mStr + dateSign + this.zeroAtFirst(now.getDate(), 2);
    return mStr;
  }
  nowTime4(): string {
    const now = new Date();
    let mStr = this.zeroAtFirst(now.getHours(), 2);
    mStr = mStr + this.zeroAtFirst(now.getMinutes(), 2);
    return mStr;
  }
  nowTime5(): string {
    const now = new Date();
    let mStr = this.zeroAtFirst(now.getHours(), 2);
    mStr = mStr + ":" + this.zeroAtFirst(now.getMinutes(), 2);
    return mStr;
  }
  nowTime6(): string {
    const now: Date = new Date();
    let mStr: string = this.zeroAtFirst(now.getHours(), 2);
    mStr = mStr + this.zeroAtFirst(now.getMinutes(), 2);
    mStr = mStr + this.zeroAtFirst(now.getSeconds(), 2);
    return mStr;
  }
  nowTime7(): string {
    const now: Date = new Date();
    let mStr: string = this.zeroAtFirst(now.getHours(), 2);
    mStr = mStr + ":" + this.zeroAtFirst(now.getMinutes(), 2);
    mStr = mStr + ":" + this.zeroAtFirst(now.getSeconds(), 2);
    return mStr;
  }
  nowTime8(): string {
    const now: Date = new Date();
    let mStr: string = this.zeroAtFirst(now.getHours(), 2);
    mStr = mStr + ":" + this.zeroAtFirst(now.getMinutes(), 2);
    mStr = mStr + ":" + this.zeroAtFirst(now.getSeconds(), 2);
    return mStr;
  }
  nowTime9(): string {
    const now: Date = new Date();
    let mStr: string = this.zeroAtFirst(now.getHours(), 2);
    mStr = mStr + this.zeroAtFirst(now.getMinutes(), 2);
    mStr = mStr + this.zeroAtFirst(now.getSeconds(), 2);
    mStr = mStr + this.zeroAtFirst(now.getMilliseconds(), 3);
    return mStr;
  }
  /**
   *
   * @returns 01:23:45.678
   */
  nowTime12(): string {
    const now: Date = new Date();
    let mStr: string = this.zeroAtFirst(now.getHours(), 2);
    mStr = mStr + ":" + this.zeroAtFirst(now.getMinutes(), 2);
    mStr = mStr + ":" + this.zeroAtFirst(now.getSeconds(), 2);
    mStr = mStr + "." + this.zeroAtFirst(now.getMilliseconds(), 3);
    return mStr;
  }
  nowDateTime(): string {
    let now = new Date();
    let mStr = now.getFullYear().toString();
    mStr = mStr + "-" + this.zeroAtFirst(now.getMonth() + 1, 2);
    mStr = mStr + "-" + this.zeroAtFirst(now.getDate(), 2);
    let hh: string = this.zeroAtFirst(now.getHours(), 2);
    let mm: string = this.zeroAtFirst(now.getMinutes(), 2);
    let ss: string = this.zeroAtFirst(now.getSeconds(), 2);
    let mSec: string = this.zeroAtFirst(now.getMilliseconds(), 3);
    mStr = mStr + "T" + hh + ":" + mm + ":" + ss + "." + mSec;
    return mStr;
  }
  // 未測試 TODO:
  numberToChinese(numX: number): string {
    var strOutput = "";
    var strUnit = "仟佰拾億仟佰拾萬仟佰拾元角分";
    let num = numX.toString();
    num += "00";
    var intPos = num.indexOf(".");
    if (intPos >= 0) num = num.substring(0, intPos) + num.substr(intPos + 1, 2);
    strUnit = strUnit.substr(strUnit.length - num.length);
    for (var i = 0; i < num.length; i++) {
      let n = Number(num.substring(i, i + 1));
      strOutput +=
        "零壹貳參肆伍陸柒捌玖".substring(n, n + 1) +
        strUnit.substring(i, i + 1);
    }
    return strOutput
      .replace(/零角零分$/, "整")
      .replace(/零[仟佰拾]/g, "零")
      .replace(/零{2,}/g, "零")
      .replace(/零([億萬])/g, "$1")
      .replace(/零元/, "元")
      .replace(/億萬/, "億")
      .replace(/^元/, "零元");
  }
  replaceTab(s: string): string {
    while (true) {
      let j = s.indexOf("\t");
      if (j < 0) {
        break;
      } else {
        s = s.substring(0, j) + "  " + s.substring(j + 1);
      }
    }
    return s;
  }
  // 將字串中的 Windows 式換行符號（CRLF）或舊式 Mac（CR）統一轉換為 Unix/Linux 式的換行符號（LF）
  replaceCRLF(s: string): string {
    if (!s) return s;
    return s.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
  }
  // 移除所有換行符號 (\r, \n)
  clearCRLF(s: string): string {
    if (!s) return s;
    return s.replace(/[\r\n]/g, '');
  }
  replaceLine(s: string, tag: string, newLine: string): string {
    s = this.replaceCRLF(s);// 將所有\r\n轉成\n
    let j = s.indexOf(tag);
    const nextLine = '\n';
    //let CR_length = nextLine.length;
    if (j < 0) {
      return s;
    } else {
      let k = s.indexOf(nextLine, j + nextLine.length);
      if (k < 2) {
        k = s.length;
      }
      let len = s.length - k;
      if (len < 0) len = 0;
      let s2 = s.substring(k + nextLine.length, s.length);
      s = s.substring(0, j) + newLine + nextLine + s2;
    }

    return s;
  }
  iif(b: boolean, xTrue: any, xFalse: any): any {
    if (b) return xTrue;
    else return xFalse;
  }
  trim(s: string): string {
    return s.trim();
  }
  // rTrim(s: string): string {
  //     return s.trimRight() // trimRight 在 nodejs 停用
  // }
  // lTrim(s: string): string {
  //     return s.trimLeft()// trimLeft 在 nodejs 停用
  // }
  /* 淺複製 */
  cloneField(from: any, to: any) {
    /*try {
      Object.keys(from).forEach((element) => {
        if (element.substring(0, 2) !== "__") {
          to[element] = from[element];
        }
      });
    } catch (error: any) { } */
    this.cloneObject(from, to);
  }
  /* 深複製 */
  deepCloneObject(from: any): any {
    let to = JSON.parse(JSON.stringify(from));
    return to;
  }

  cloneObject(from: any, to: any) {
    //if (!to) to = {};
    if (!to) {
      alert('cloneObject to is null,必須先建立物件');
      return;
    }

    try {
      Object.keys(from).forEach((element) => {
        to[element] = from[element];
      });
    } catch (error: any) { }
  }
  // 使用深拷貝函數和遞迴： #cloneCopy
  deepCopy(obj: any): any {
    if (typeof obj !== "object" || obj === null) {
      return obj;
    }

    let copy: any | any[];
    if (Array.isArray(obj)) {
      copy = [];
    } else {
      copy = {};
    }

    for (let key in obj) {
      if (typeof obj[key] === "object" && obj[key] !== null) {
        if (Array.isArray(obj[key])) {
          copy[key] = this.deepCopyArray(obj[key]);
        } else {
          copy[key] = this.deepCopy(obj[key]);
        }
      } else {
        copy[key] = obj[key];
      }
    }

    return copy;
  }

  // let ary = [[1,1], [2,2]]
  // let newAry = Object.assign([],ary) object assign 只能處理一層
  deepCopyArray(obj: any[]): any[] {
    let copy: any[] = [];
    for (let key in obj) {
      if (typeof obj[key] === "object" && obj[key] !== null) {
        if (Array.isArray(obj[key])) {
          copy[key] = this.deepCopyArray(obj[key]);
        } else {
          copy[key] = this.deepCopy(obj[key]);
        }
      } else {
        copy[key] = obj[key];
      }
    }

    return copy;
  }
  /**
   * 淺層比較兩個物件的內容是否相同。
   * @param obj1 物件一
   * @param obj2 物件二
   * @returns 如果兩個物件的屬性與值（淺層）皆相同，則回傳 true。
   */
  compareObject(obj1: any, obj2: any): boolean {
    // 如果是同一個物件實例，直接回傳 true
    if (obj1 === obj2) {
      return true;
    }

    // 如果任一不是物件或為 null，則它們不相等
    if (obj1 == null || obj2 == null || typeof obj1 !== 'object' || typeof obj2 !== 'object') {
      return false;
    }

    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);

    // 如果屬性數量不同，則它們不相等
    if (keys1.length !== keys2.length) {
      return false;
    }

    // 迭代所有屬性，並比較它們的值
    for (const key of keys1) {
      // 如果 obj2 沒有這個屬性，或者屬性值不同，則它們不相等
      if (!Object.prototype.hasOwnProperty.call(obj2, key) || obj1[key] !== obj2[key]) {
        return false;
      }
    }

    // 所有檢查都通過，物件相等
    return true;
  }

  countTime4(t1: string, count: number): any {
    let i1: number =
      this.fixNumber(t1.substring(0, 2)) * 60 +
      this.fixNumber(t1.substring(2, 2 + 2)) +
      count;
    let mOverOneDay = 0;
    //檢查合法值 -> 到後幾天去了
    while (i1 > 1440) {
      mOverOneDay += 1;
      i1 = i1 - 1440; //24*60=1440
    }
    while (i1 < 0) {
      mOverOneDay -= 1;
      i1 = i1 + 1440; //24*60=1440
    }
    let mNewHour = Math.floor(i1 / 60); // div 60
    let mNewMinute = i1 % 60; // mod
    let t2 = this.zeroAtFirst(mNewHour, 2) + this.zeroAtFirst(mNewMinute, 2);

    return [mOverOneDay, t2];
  }
  countTime8(t1: string, countSec: number): any {
    let i1: number =
      this.fixNumber(t1.substring(0, 2)) * 60 * 60 +
      this.fixNumber(t1.substring(3, 3 + 2)) * 60 +
      this.fixNumber(t1.substring(6, 6 + 2)) +
      countSec;
    let mOverOneDay = 0;
    //檢查合法值 -> 到後幾天去了
    while (i1 > 86400) {
      mOverOneDay += 1;
      i1 = i1 - 86400; //24*60=1440
    }
    while (i1 < 0) {
      mOverOneDay -= 1;
      i1 = i1 + 86400; //24*60=1440
    }
    let mSecond = i1 % 60; // mod
    i1 = Math.floor((i1 - mSecond) / 60); // 轉成分鐘
    let mNewMinute = i1 % 60; // mod
    i1 = i1 - mNewMinute;
    let mNewHour = Math.floor(i1 / 60); // div 60
    let t2 =
      this.zeroAtFirst(mNewHour, 2) +
      ":" +
      this.zeroAtFirst(mNewMinute, 2) +
      ":" +
      this.zeroAtFirst(mSecond, 2);

    return [mOverOneDay, t2];
  }
  dateField2Date(xDate: string): Date | undefined {
    return this.TransDateIn(xDate);
  }
  countTime(xNowTime: string, xChangeTime: string, xStyle: number): any {
    let mNowTime = 0, mChangeTime = 0, mStyle: number;
    let mNewTime = 0, mNewHour = 0, mNewMinute: number;
    let mOverOneDay: boolean = false;
    let mStr: String;

    // mNewTime=0;
    // 是否跨天,改變後之時分
    let result = [mOverOneDay, '0000'];
    if (xNowTime.length !== 4 || xChangeTime.length !== 4) {
      result[1] = '錯誤';
      return result;
    }
    try {
      if (xStyle > 0)
        mStyle = 1
      else if (xStyle < 0)
        mStyle = -1
      else
        mStyle = 0;
      // 把原始時間轉成分
      mStr = xNowTime; // = Format('%.*d', [4, StrToIntDef(xNowTime, 0)]);
      mNowTime = this.fixNumber(mStr.substring(0, 2)) * 60 +
        this.fixNumber(mStr.substring(2, 4));
      // 把要改之時間轉成分
      mStr = xChangeTime;
      mChangeTime = this.fixNumber(mStr.substring(0, 2)) * 60 +
        this.fixNumber(mStr.substring(2, 4));
      // xStyle: 1-> 增加 , -1 -> 減少
      mChangeTime = mChangeTime * mStyle;
      // 算一算
      mNewTime = mNowTime + mChangeTime;
      // 檢查合法值 -> 到前幾天去了
      while (mNewTime < 0) {
        mOverOneDay = true;
        mNewTime = mNewTime + 1440; // 24*60=1440
      };
      // 檢查合法值 -> 到後幾天去了
      while (mNewTime > 1440) {

        mOverOneDay = true;
        mNewTime = mNewTime - 1440; // 24*60=1440
      };
      // 轉換回時分
      mNewHour = Math.floor(mNewTime / 60);
      mNewMinute = mNewTime % 60;
      result = [mOverOneDay, this.zeroAtFirst(mNewHour, 2) + this.zeroAtFirst(mNewMinute, 2)];
    } catch (e: any) {
      logger.error('countTime error: ' + e.message);
      result[1] = '錯誤';
    }
    return result;
  }

  countDate(xDate: string, xKind: string, xMove: number): string {
    let mDate: string;
    let myDate: Date | undefined = this.TransDateIn(xDate);
    if (!myDate) return "";
    xKind = xKind.toUpperCase();
    if (xKind === "Y") {
      // 算年
      //mYY=mYY+xMove;
      //myDate = new Date(Date.UTC(mYY, mMM - 1, mDD, 0, 0, 0));
      myDate.setFullYear(myDate.getFullYear() + xMove);
      mDate = this.date2DateField(myDate);
      return mDate;
    } else if (xKind === "M") {
      // 算月
      /*
          let mMonth =mYY*12+mMM+xMove; // 先全部換成月份
          mMM =mMonth % 12 ;
          if( mMM===0){

            mMM =12;
            mYY =Math.trunc(mMonth / 12)-1;
          }else{
            mYY = mMonth / 12;
          while True do
          begin
            try
              // ^_^ jackie 20161102    add begin
              if (mMM=4) OR (mMM=6) OR (mMM=9) OR (mMM=11) then
              begin
                if mDD > 30 then
                  mDD = 30;
              end;
              // ^_^ jackie 20161102    add end
              Mydate=EncodeDate(mYY,mMM,mDD);
              break;
            except
              mDD=mDD-1;
            end;
          end;*/
      myDate.setMonth(myDate.getMonth() + xMove);
      mDate = this.date2DateField(myDate);
      return mDate;
    } else {
      if (xKind === "D") {
        // 算日
        myDate.setDate(myDate.getDate() + xMove);
      } //else       exit;   // 不是 Y or M or D 格式那就沒法度了
      mDate = this.date2DateField(myDate);
      return mDate;
    }
  }
  date10toDate8(xDate: string): string {
    //mXA002 = Copy(mStr, 1, 4) + Copy(mStr, 6, 2) + Copy(mStr, 9, 2);
    if (xDate.length !== 10) return "";
    else
      return (
        xDate.substring(0, 4) +
        xDate.substring(5, 5 + 2) +
        xDate.substring(8, 8 + 2)
      );
  }
  // 多行string 轉 string[]
  string2List(data: string): string[] {
    let splitStr: string;
    let list: string[];
    splitStr = "\r\n";
    if (data.indexOf(splitStr) > 0) {
      list = data.split(splitStr);
    } else {
      splitStr = "\n";
      list = data.split(splitStr);
    }
    return list;
  }
  bigIntDiv(data: string, len: number): BigInt {
    let tmp: string = this.swapStr(data, ",", ""); // 拿掉 千分位 ,
    tmp = tmp.substring(0, tmp.length - len); // element[2].substring(0,element[2].length-3)
    let ret: BigInt;
    ret = this.strToBigInt(tmp);
    return ret;
  }
  IntDiv(data: string, len: number): number {
    let tmp: string = this.swapStr(data, ",", ""); // 拿掉 千分位 ,
    tmp = tmp.substring(0, tmp.length - len); // element[2].substring(0,element[2].length-3)
    return Number(tmp);
  }
  arrayMax(data: number[], from: number, length: number): number {
    let ret: number[] = [];
    ret = data.slice(from, from + length);
    let m = Math.max(...ret);
    return m;
  }
  arrayMin(data: number[], from: number, length: number): number {
    let ret: number[] = [];
    ret = data.slice(from, from + length);
    let m = Math.min(...ret);
    return m;
  }
  arrAvg(arr: number[]): number {
    return arr.reduce((a, b) => a + b, 0) / arr.length;
  }
  arrayAvg(data: number[], from: number, length: number): number {
    let ret: number[] = [];
    ret = data.slice(from, from + length);
    let m = this.arrAvg(ret);
    return m;
  }
  arraySum(data: number[], from: number, length: number): number {
    let ret: number[] = [];
    ret = data.slice(from, from + length);
    let m = this.arrSum(ret);
    return m;
  }
  arrSum(arr: number[]) {
    return arr.reduce((a, b) => {
      let x = a + b; // jackie 20211008
      return x;
    }, 0);
  }
  percentStr(n: number, scale: number): string {
    let s: string;
    let n2: number;
    n2 = this.fourOutFiveIn(n * 100, scale);
    return n2.toString() + "%";
  }
  upperCaseFirst(s: string): string {
    let retStr: string = "";
    if (s.length > 0) {
      retStr =
        s.substring(0, 1).toUpperCase() +
        s.substring(1, s.length).toLowerCase();
    }

    return retStr;
  }
  fixString(x: any): string {
    let s: string = String(x);
    s = s.trim();
    if (s === "undefined" || s === "null" || s === "nil") {
      s = "";
    }
    return s;
  }
  fixNumber(x: any): number {
    let s: number = Number(x);
    if (!Number.isFinite(s)) {
      s = 0;
    }
    if (Number.isNaN(s)) {
      s = 0;
    }
    return s;
  }
  fixBoolean(x: any): boolean {
    let type = typeof x;
    let b: boolean;
    if (type === "string") {
      if (x === "true") {
        return true;
      } else {
        return false;
      }
    }
    if (type === "boolean") {
      return x;
    }
    if (x === undefined) {
      return false;
    }
    return false;
  }
  dateColumn2Display(options: any): string {
    // debugger;
    if (options.value === undefined) return "";
    let yy = "";
    let mm = "";
    let dd = "";
    const mStr: string = options.value;
    yy = mStr.substring(0, 4);
    mm = mStr.substring(4, 4 + 2);
    dd = mStr.substring(6, 6 + 2);
    return yy + "/" + mm + "/" + dd;
  }
  timeField2Display(options: any): string {
    // debugger;
    if (options.value === undefined) return "";
    let hh = "";
    let mm = "";
    const mStr: string = options.value;
    hh = mStr.substring(0, 2);
    mm = mStr.substring(2, 2 + 2);
    return hh + ":" + mm;
  }
  //timeCheck(data: string, mRet: jkRestReturnClass): boolean  {
  timeCheck(data: string): jkRestReturn {
    let mRet: jkRestReturn = new jkRestReturnClass();
    // debugger;
    if (data === undefined) {
      mRet.result = true;
    } else {
      if (data === "") {
        mRet.result = true;
      } else {
        if (data.length !== 4) {
          mRet.message = "時間格式為4位數字.24小時制.例如: 1359 表示 13:59 ";
          mRet.result = false;
        } else {
          mRet.result = true;
          const hh = data.substring(0, 2);
          const mm = data.substring(2, 2 + 2);
          const hour = parseInt(hh, 10);
          if (!(hour >= 0 && hour <= 23)) {
            mRet.message = "時間格式為4位數字.24小時制.例如: 1359 表示 13:59 ";
            mRet.result = false;
          }
          const min = parseInt(mm, 10);
          if (!(min >= 0 && min <= 59)) {
            mRet.message = "時間格式為4位數字.24小時制.例如: 1359 表示 13:59 ";
            mRet.result = false;
          }
        }
      }
    }
    return mRet;
  }
  timeFieldCheck(options: any): boolean {
    if (options.value.length !== 4) {
      options.rule.message =
        "時間格式為4位數字.24小時制.例如: 1359 表示 13:59 ";
      return false;
    } else {
      const hh = options.value.substring(0, 2);
      const mm = options.value.substring(2, 2 + 2);
      const hour = parseInt(hh, 10);
      if (!(hour >= 1 && hour <= 24)) {
        options.rule.message =
          "時間格式為4位數字.24小時制.例如: 1359 表示 13:59 ";
        return false;
      }
      let min = parseInt(mm, 10);
      if (!(min >= 0 && min <= 59)) {
        options.rule.message =
          "時間格式為4位數字.24小時制.例如: 1359 表示 13:59 ";
        return false;
      }
      return true;
    }
  }
  dateCheck(data: string, msg: string = ''): boolean {
    msg = "日期格式為西元.斜線分隔(/).例如: 20150102 表示 2015/01/02 ";
    if (data.length !== 8) {
      return false;
    } else {
      const yy = data.substring(0, 4);
      const mm = data.substring(4, 4 + 2);
      const dd = data.substring(6, 6 + 2);
      const year = parseInt(yy, 10);
      const month = parseInt(mm, 10);
      const day = parseInt(dd, 10);
      try {
        let d = new Date();
        d.setFullYear(year, month - 1, day);
        let mStr: string = this.date2DateField(d);

        if (mStr !== data) {
          return false;
        } else return true;
      } catch (e: any) {
        return false;
      }
    }
  }
  dateFieldCheck(options: any): boolean {
    const msg: string =
      "日期格式為西元.斜線分隔(/).例如: 20150102 表示 2015/01/02 ";
    try {
      if (options.value.length === 0) {
        return true;
      } else if (options.value.length !== 8) {
        options.rule.message = msg;
        return false;
      } else {
        const yy = options.value.substring(0, 4);
        const mm = options.value.substring(4, 4 + 2);
        const dd = options.value.substring(6, 6 + 2);
        const year = parseInt(yy, 10);
        const month = parseInt(mm, 10);
        const day = parseInt(dd, 10);
        try {
          let d = new Date();
          d.setFullYear(year, month - 1, day);
          let mStr: string = "";
          // mStr = this.date2DateField(d);
          mStr = this.date2DateField(d);
          if (mStr !== options.value) {
            return false;
          } else return true;
        } catch (e: any) {
          return false;
        }
      }
    } catch (e: any) {
      logger.error(e.message, "dateFieldCheck");
      return false;
    }
  }
  timeRange(xBeginTime: string, xEndTime: string, xType: string): any {
    // 若時間格式不對.回傳0
    let mBeginTime: number;
    let mEndTime: number;
    let mChangeTime: number;
    let mNewHour: number;
    let mNewMinute: number;
    let mStr: string;
    let mOverOneDay: boolean;
    // debugger;
    mOverOneDay = false;
    if (xBeginTime === undefined) {
      xBeginTime = "";
    }
    if (xEndTime === undefined) {
      xEndTime = "";
    }
    if (xEndTime === "") {
      xEndTime = xBeginTime;
    }

    // 先全轉換成分
    try {
      mStr = xBeginTime;
      mBeginTime =
        parseInt(this.Copy(mStr, 1, 2), 10) * 60 +
        parseInt(this.Copy(mStr, 3, 2));
      mStr = xEndTime;
      mEndTime =
        parseInt(this.Copy(mStr, 1, 2)) * 60 + parseInt(this.Copy(mStr, 3, 2));
    } catch (err) {
      mEndTime = 0;
      mBeginTime = 0;
    }
    if (
      this.timeCheck(xBeginTime).result === false ||
      this.timeCheck(xEndTime).result === false
    ) {
      // 若時間格式不對.回傳0
      mEndTime = 0;
      mBeginTime = 0;
    }
    //算一算
    if (isNaN(mBeginTime) || isNaN(mEndTime)) mChangeTime = 0;
    else mChangeTime = mEndTime - mBeginTime;
    if (isNaN(mChangeTime)) mChangeTime = 0;
    //檢查合法值 -> 到前幾天去了
    while (mChangeTime < 0) {
      mOverOneDay = true;
      mChangeTime = mChangeTime + 1440; //24*60=1440
    }
    //檢查合法值 -> 到後幾天去了
    while (mChangeTime > 1440) {
      mOverOneDay = true;
      mChangeTime = mChangeTime - 1440; //24*60=1440
    }
    mNewHour = Math.floor(mChangeTime / 60); // div 60
    mNewMinute = mChangeTime % 60; // mod
    mChangeTime = this.fourOutFiveIn(mChangeTime, 2);
    if (xType === "1") {
      // 傳回時分(ex: 1201)
      return [
        mOverOneDay,
        this.zeroAtFirst(mNewHour, 2) + this.zeroAtFirst(mNewMinute, 2),
      ];
    } else if (xType === "2") {
      // 傳回時 (ex: 12.01666666)
      return [mOverOneDay, mChangeTime / 60];
    } else if (xType === "3") {
      // 傳回分 (ex: 721)
      return [mOverOneDay, mChangeTime];
    } else if (xType === "9") {
      // 傳回全部(時分,時,分)
      return [
        mOverOneDay,
        this.zeroAtFirst(mNewHour, 2) + this.zeroAtFirst(mNewMinute, 2),
        mChangeTime / 60,
        mChangeTime,
      ];
    } else {
      return [false, "0000", 0.0, 0.0];
    }
  }
  date2DateField(mydate: any): string {
    // debugger;
    let mStr = "";
    if (mydate === undefined) return '';
    if (mydate === null) return '';

    if (typeof mydate === "object") {
      try {
        mStr = mydate.getFullYear().toString();
        mStr = mStr + this.zeroAtFirst(mydate.getMonth() + 1, 2);
        mStr = mStr + this.zeroAtFirst(mydate.getDate(), 2);
      } catch (error: any) {
        return "";
      }
    } else if (typeof mydate === "string") {
      // debugger;
      mStr =
        mydate.substring(0, 4) +
        mydate.substring(5, 5 + 2) +
        mydate.substring(8, 8 + 2);
    } else {
      if (typeof mydate === "undefined") {
        mStr = "";
      }
    }
    return mStr;
  }
  time2TimeField(mydate: Date): string {
    // debugger;
    let mStr = "";
    if (typeof mydate === "object") {
      mStr =
        this.zeroAtFirst(mydate.getHours(), 2) +
        this.zeroAtFirst(mydate.getMinutes(), 2);
    }
    return mStr;
  }
  TransDateIn(date1: any): Date | undefined {
    if (typeof date1 === "string") {
      if (!this.dateCheck(date1)) {
        return undefined;
      }
      //let dd = new Date(Number(date1.substring(0, 4)), Number(date1.substring(4, 2)) - 1, Number(date1.substring(6, 2)));
      let dd = new Date(
        Date.UTC(
          Number(date1.substring(0, 4)),
          Number(date1.substring(4, 4 + 2)) - 1,
          Number(date1.substring(6, 6 + 2)),
          0,
          0,
          0
        )
      ); // jackie 20200716 modi
      return dd;
    } else {
      return date1;
    }
  }
  display2Datefield(date: string, sep: string): string {
    if (date === "") {
      return "";
    } else {
      if (date === undefined) {
        return "";
      } else {
        let result: string =
          this.getToken(date, sep, 1) +
          this.getToken(date, sep, 2) +
          this.getToken(date, sep, 3);
        return result;
      }
    }
  }
  display2Time6(time: string): string {
    let result: string =
      this.getToken(time, ":", 1) +
      this.getToken(time, ":", 2) +
      this.getToken(time, ":", 3);
    return result;
  }
  display2Time4(time: string): string {
    let result: string =
      this.getToken(time, ":", 1) + this.getToken(time, ":", 2);
    return result;
  }
  display2TimeField(time: string): string {
    let result: string =
      this.getToken(time, ":", 1) + this.getToken(time, ":", 2);
    return result;
  }
  //jsEncode(input: string, charset: any): string {
  jsEncode(input: string): string {
    //https://coderstoolbox.net/string/string.js
    let output = "";
    for (let i = 0; i < input.length; i++) {
      const j = "\b\t\n\v\f\r\"'\\".indexOf(input.charAt(i));
      if (j !== -1) {
        output += "\\" + "btnvfr\"'\\".substring(j, j + 1);
      } else if (input.substring(i, i + 2) === "</") {
        output += "<\\/";
        i++;
        /*} else if (!charset.containsChar(input.charAt(i))) {
            if (input.charCodeAt(i) > 255) {
                output += '\\u' + ('000' + input.charCodeAt(i).toString(16)).right(4);
            } else {
                output += '\\x' + ('0' + input.charCodeAt(i).toString(16)).right(2);
            }
        } else {*/
        output += input.charAt(i);
      }
    }
    return output;
  }
  range2Where(
    text1: string,
    text2: string,
    xWhere: string,
    xField: string
  ): string {
    if (!text1 && !text2) {
      return xWhere;
    }
    if (!text2) {
      return xWhere;
    }
    text1 = text1.trim();
    text2 = text2.trim();
    if (text2 !== "") {
      return (
        xWhere +
        " AND ((" +
        xField +
        ">=" +
        this.quotedStr(text1) +
        ") AND (" +
        xField +
        "<=" +
        this.quotedStr(text2) +
        " )) "
      );
    } else return xWhere;
  }
  /** TagBox,Drop down Box 或多選組SQL WHERE */
  objectArray2Where(
    xRetField: string,
    xAry: Array<any>,
    xWhere: string,
    xField: string
  ): string {
    //debugger
    if (!xAry) {
      return xWhere;
    }
    let mRet: string = "";
    if (xAry === undefined) {
      return xWhere;
    }
    for (let i = 0; i < xAry.length; i++) {
      if (xAry[i][xRetField] === undefined) continue;
      if (mRet === "") {
        mRet = "N" + this.quotedStr(xAry[i][xRetField]);
      } else {
        mRet = mRet + ",N" + this.quotedStr(xAry[i][xRetField]);
      }
    }
    if (mRet.length > 0) {
      return xWhere + " AND " + xField + " IN ( " + mRet + " )";
    } else {
      return xWhere;
    }
  }
  yn2Where(yn: string, xWhere: string, xField: string): string {
    if (!yn) {
      return xWhere;
    }
    if (yn === "Y" || yn === "N") {
      return xWhere + " AND (" + xField + "='" + yn + "') ";
    } else return xWhere;
  }
  bool2Where(bool: boolean, xWhere: string, xField: string): string {
    if (bool === undefined) {
      return xWhere;
    }
    if (bool) {
      return xWhere + ` AND (${xField} ='Y') `;
    } else
      return xWhere + ` AND (${xField} ='N') `;
  }
  text2Where(
    text: string,
    xWhere: string,
    xField: string,
    oper: string
  ): string {
    if (!text) {
      return xWhere;
    }
    text = text.trim();
    if (text !== "") {
      return xWhere + " AND (" + xField + oper + this.quotedStr(text) + ") ";
    } else return xWhere;
  }
  number2Where(
    n: number,
    xWhere: string,
    xField: string,
    oper: string
  ): string {
    if (n === 0) {
      return xWhere;
    }
    if (n !== 0) {
      return xWhere + " AND (" + xField + oper + n.toString() + ") ";
    } else return xWhere;
  }
  JSdate2SQLTime(d: Date): string {
    //let s = d.toISOString();
    //s = this.swapStr(s,'Z',' ');
    let h = d.getTimezoneOffset(); //分
    let d2 = new Date();
    d2.setTime(d.getTime() - h * 60 * 1000);
    let s2 = d2.toISOString();
    //date.setTime(date.getTime() + numOfHours * 60 * 60 * 1000);
    return s2;
  }
  isEmpty(value: any): boolean {
    if (value === null || value === undefined) return true;
    if (typeof value === 'string') return value.trim().length === 0;
    if (typeof value === 'number') return value === 0;
    if (typeof value === 'boolean') return !value;
    if (Array.isArray(value)) return value.length === 0;
    if (typeof value === 'object') {
      // 也能同時擋掉空陣列 []
      if (Object.keys(value).length === 0) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  linkFieldSet2Object(linkFieldSet: string, from: any): any {
    let obj: any = {}; // 千萬不要改成 undefined，否則無法設定值
    if (this.isEmpty(from)) {
      return obj;
    }
    let ary: string[] = linkFieldSet.split(",");
    try {
      for (let i = 0; i < ary.length; i++) {
        let temp: string[] = ary[i].split("=");
        obj[temp[0]] = from[temp[1]];
      }
    } catch (error: any) {
      alert('linkFieldSet2Object: ' + error.message + ' linkFieldSet: ' +
        linkFieldSet + ' from: ' + JSON.stringify(from));
    }
    return obj;
  }
  calcDaysBetweenDates(date1: string, date2: string): number {
    let d1: Date = new Date(date1);
    let d2: Date = new Date(date2);
    let diff = Math.abs(d1.getTime() - d2.getTime());
    let diffDays = Math.ceil(diff / (1000 * 3600 * 24));
    return diffDays;
  }
  timeStamp2Datetime(x: number): string {
    // multiplied by 1000 so that the argument is in milliseconds, not seconds.
    const date = new Date(x);
    return date.toLocaleString();
  }

  timeStamp2Time5(x: number): string {
    // multiplied by 1000 so that the argument is in milliseconds, not seconds.
    const date = new Date(x * 1000);
    // Hours part from the timestamp
    const hours = date.getHours();
    // Minutes part from the timestamp
    const minutes = date.getMinutes();
    // Seconds part from the timestamp
    const seconds = date.getSeconds();
    let time4: string;
    time4 = this.zeroAtFirst(hours, 2) + ":" + this.zeroAtFirst(minutes, 2);
    return time4;
  }
  /**
   * 測試typeof d 是否日期
   * @param {any} d :要測試的object
   * @returns {boolean}:是日期回傳true
   */
  isJSDate(d: any): boolean {
    if (typeof d === "string") {
      try {
        const a = new Date(d);
        return true;
      } catch (error: any) {
        return false;
      }
    } else {
      return false;
    }
  }
  isJSBoolean(b: any): boolean {
    if (typeof b === "boolean") {
      return true;
    } else {
      return false;
    }
  }
  checkStatus(res: any) {
    if (res.ok) {
      // res.status >= 200 && res.status < 300
      return res;
    } else {
      //throw MyCustomError(res.statusText);
      const msg =
        "XXX " + res.url + " " + String(res.status) + " " + res.statusText;
      logger.error(msg);
    }
  }
  fetchError(err: any, resFrom: any) {
    logger.error("fetchError:", err);
    resFrom.send(err);
  }

  pos(xSubStr: string, xStr: string): number {
    return xStr.indexOf(xSubStr);
  }
  intToStr(i: number): string {
    return i.toString();
  }
  StrToInt(xStr: string): number {
    xStr = this.swapStr(xStr, ",", ""); // 拿掉 千分位 ,
    return parseInt(xStr);
  }
  strToInt(xStr: string): number {
    return this.StrToInt(xStr);
  }
  strToBigInt(xStr: string): BigInt {
    xStr = this.swapStr(xStr, ",", ""); // 拿掉 千分位 ,
    return BigInt(xStr);
  }
  strToFloat(xStr: string): number {
    xStr = this.swapStr(xStr, ",", ""); // 拿掉 千分位 ,
    return parseFloat(xStr);
  }
  toSeqDate(
    xDateType: number,
    xYearLen: number,
    xDate: string,
    xKind: number
  ): string {
    let Result: string = "";
    let mYear: string = "";
    let mMonth: string = "";
    let mDate: string = ""; //  請先完成轉換要顯示出來的日期格式
    switch (xDateType) {
      case 1:
        break; // 1, 4, 5: //YYYYMMDD E.  YYMMDD C. YYYMMDD C.
      case 4:
        break;
      case 5:
        // code block
        mYear = this.Copy(xDate, 1, xDate.length - 4);
        mYear = this.padL(
          this.Copy(mYear, mYear.length - xYearLen + 1, xYearLen),
          [xYearLen, 48]
        );
        mMonth = this.Copy(xDate, xDate.length - 3, 2);
        mDate = this.Copy(xDate, xDate.length - 1, 2);
        break;
      case 2:
        // code block
        mYear = this.Copy(xDate, 5, xDate.length);
        mYear = this.padL(
          this.Copy(mYear, mYear.length - xYearLen + 1, xYearLen),
          [xYearLen, 48]
        );
        mMonth = this.Copy(xDate, 1, 2);
        mDate = this.Copy(xDate, 3, 2);
        break;
      case 3:
        // code block
        mYear = this.Copy(xDate, 5, xDate.length);
        mYear = this.padL(
          this.Copy(mYear, mYear.length - xYearLen + 1, xYearLen),
          [xYearLen, 48]
        );
        mMonth = this.Copy(xDate, 3, 2);
        mDate = this.Copy(xDate, 1, 2);
        break;
      default:
      // code block
    }
    switch (xKind) {
      case 1:
        Result = mYear + mMonth + mDate; //日編
        break;
      case 2:
        Result = mYear + mMonth; //月編
        break;
      case 5:
        Result = mYear; //年編
        break;
      default:
    }

    return Result;
  }

  padL(str: string, others: Array<any>): string {
    //左填字元  padL('A',[4,'0'])-->000A
    let cFiller: string = " ";
    const nAlen: number = others.length;
    if (nAlen > 1) {
      cFiller = others[1];
    }
    //str.padStart(others[0], cFiller); // ???  若中文字有誤
    return this.padStart(str, others[0], cFiller);
  }
  padStart(oldStr: string, targetLength: number, padString: string): string {
    // ES2016或以上才能用. 乾脆CALL自己寫的
    // targetLength = targetLength >> 0; //truncate if number or convert non-number to 0;
    if (typeof targetLength !== "number") {
      targetLength = 0;
    }
    padString = String(typeof padString !== "undefined" ? padString : " ");
    if (oldStr.length > targetLength) {
      return String(oldStr);
    } else {
      targetLength = targetLength - oldStr.length;
      if (targetLength > padString.length) {
        padString += padString.repeat(targetLength / padString.length); //append to original to ensure we are longer than needed
      }
      return padString.slice(0, targetLength) + String(oldStr);
    }
  }
  padEnd(oldStr: string, targetLength: number, padString: string): string {
    // ES2016或以上才能用. 乾脆CALL自己寫的
    // targetLength = targetLength >> 0; //truncate if number or convert non-number to 0;
    if (typeof targetLength !== "number") {
      targetLength = 0;
    }
    padString = String(typeof padString !== "undefined" ? padString : " ");
    if (oldStr.length > targetLength) {
      return String(oldStr);
    } else {
      targetLength = targetLength - oldStr.length;
      if (targetLength > padString.length) {
        padString += padString.repeat(targetLength / padString.length); //append to original to ensure we are longer than needed
      }
      return String(oldStr) + padString.slice(0, targetLength);
    }
  }
  padR(str: string, others: Array<any>): string {
    // 右填字元
    let cFiller: string = " ";
    let nAlen: number = others.length;
    if (nAlen > 1) {
      cFiller = others[1];
    }
    //str.padEnd(others[0], cFiller); // ???  若中文字有誤
    return this.padEnd(str, others[0], cFiller);
  }

  /** 加左右單引號 */
  quotedStr(xStr: string): string {
    return "'" + xStr + "'";
  }
  /** 加左右雙引號 */
  DoubleQuotedStr(xStr: string): string {
    return '"' + xStr + '"';
  }
  /** 去除左右單引號 或 雙引號 */
  deleteQuotedStr(xStr: string): string {
    let len = xStr.length;
    if (len < 2) return xStr;
    return xStr.substring(1, len - 1);
  }

  getBrackets(xStr: string): string {
    let result = "";

    let x = this.cutToken(xStr, "("); // xStr.split('(')
    let ms = x[1];
    x = this.cutToken(ms, ")"); // split(')');
    return x[0];
  }
  fourOutFiveIn(x: number, pos: number): number {
    const size = Math.pow(10, pos);
    let r = Math.round(x * size) / size;
    return r;
  }
  abs(n: number) {
    return Math.abs(n);
  }

  numToken(keyFields: string, subStr: string): number {
    let x = keyFields.split(subStr);
    return x.length;
  }

  getToken(keyFields: string, subStr: string, i: number): string {
    let x = keyFields.split(subStr);
    if (i > x.length) return "";
    return x[i - 1];
  }
  cutToken(xStr: any, sDelim: string): string[] {
    if (!xStr) return ["", ""];
    let mStr: string = xStr;
    let ms1: string = "";
    let ms2: string = "";
    let mIndex: number;
    try {
      mIndex = mStr.indexOf(sDelim);
      if (mIndex < 0) {
        ms1 = mStr;
        ms2 = "";
      } else {
        ms1 = mStr.substring(0, mIndex).trim();
        //ms2 = mStr.substring(mIndex + sDelim.length, mStr.length - (mIndex + sDelim.length)).trim();
        ms2 = mStr.substring(mIndex + sDelim.length).trim(); // jackie 20220913 modi
      }
    } catch (e: any) {
      logger.error("cutToken Error:", e.message);
    }
    //xStr = ms2;// 可能無法回傳
    return [ms1, ms2];
  }
  cutToken1(xStr: any, sDelim: string): string {
    let mStr: string = xStr;
    let ms1: string = "";
    let ms2: string = "";
    let mIndex: number;
    //debugger;
    try {
      mIndex = mStr.indexOf(sDelim);
      if (mIndex < 0) {
        ms1 = mStr;
        ms2 = "";
      } else {
        ms1 = mStr.substring(0, mIndex).trim();
        //ms2 = mStr.substring(mIndex + sDelim.length, mStr.length - (mIndex + sDelim.length)).trim();
        //ms2 = mStr.substring(mIndex + sDelim.length).trim();  // jackie 20220913 modi
      }
    } catch (e: any) {
      logger.error(e.message, "cutToken Error!");
    }
    //xStr = ms2;// 可能無法回傳
    return ms1;
  }
  cutToken2(xStr: any, sDelim: string): string {
    let mStr: string = xStr;
    let ms1: string = "";
    let ms2: string = "";
    let mIndex: number;
    //debugger;
    try {
      mIndex = mStr.indexOf(sDelim);
      if (mIndex < 0) {
        ms1 = mStr;
        ms2 = "";
      } else {
        //ms1 = mStr.substring(0, mIndex).trim();
        //ms2 = mStr.substring(mIndex + sDelim.length, mStr.length - (mIndex + sDelim.length)).trim();
        ms2 = mStr.substring(mIndex + sDelim.length).trim(); // jackie 20220913 modi
      }
    } catch (e: any) {
      logger.error(e.message, "cutToken Error!");
    }
    //xStr = ms2;// 可能無法回傳
    return ms2;
  }
  GetBrackets(xStr: string): string {
    let ms = this.cutToken(xStr, "(");
    xStr = ms[1];
    ms = this.cutToken(xStr, ")");
    return ms[0];
  }
  cutToken2Ary(xStr: string, sDelim: string): any {
    let mRet;
    let ms1: string = "";
    let ms2: string = "";
    let mIndex: number;
    //debugger;
    try {
      mIndex = xStr.indexOf(sDelim);
      if (mIndex < 0) {
        ms1 = xStr;
        ms2 = "";
      } else {
        ms1 = xStr.substring(0, mIndex).trim();
        //ms2 = xStr.substring(mIndex + sDelim.length, xStr.length - (mIndex + sDelim.length - 1)).trim();
        //ms2 = xStr.substring(mIndex + sDelim.length, xStr.length - (mIndex + sDelim.length)).trim();
        ms2 = xStr.substring(mIndex + sDelim.length).trim(); // jackie 20220913 modi
      }
    } catch (e: any) {
      logger.error(e.message, "cutToken Error!");
    }
    mRet = [ms1, ms2];
    return mRet;
  }
  /**
   * 可能無窮迴圈
   * @param xStr
   * @param xFrom
   * @param xReplace
   * @returns
   */
  swapStr(xStr: string, xFrom: string, xReplace: string): string {
    let retStr = '';
    if (xStr) {
      while (xStr.indexOf(xFrom) >= 0) {
        // TODO:  ?? 為何 ) 無法REPLACE,\n replace \n\r 這樣會無窮迴圈
        xStr = xStr.replace(xFrom, xReplace); // swapStr(sqlSelect,',',' ');
      }
    }
    return xStr;
  }
  /**
   * 未完成
   * @param xStr
   * @param xFrom
   * @param xReplace
   * @returns
   */
  swapStr2(xStr: string, xFrom: string, xReplace: string): string {
    let retStr = '';
    if (xStr) {
      let mIndex: number = 0;
      mIndex = xStr.indexOf(xFrom);
      //let ms1 = jkLib.cutToken(xStr, xFrom);
      while (mIndex >= 0) {
        // TODO:  ?? 為何 ) 無法REPLACE,\n replace \n\r 這樣會無窮迴圈
        xStr = xStr.replace(xFrom, xReplace); // swapStr(sqlSelect,',',' ');
        mIndex = xStr.indexOf(xFrom, mIndex + xReplace.length + 1);
      }
    }
    return xStr;
  }
  sortArray(ary: Array<any>, keyFields: string): boolean {
    let mBool: boolean = false;
    let mKey1: string;
    let mKey2: string;
    let mCount: number;
    let keyAry: Array<any>;
    keyAry = keyFields.split(",");
    try {
      ary.sort((a, b): number => {
        mKey1 = "";
        mKey2 = "";
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for (let i = 0; i < keyAry.length; i++) {
          mKey1 = mKey1 + a[keyAry[i].trim()];
          mKey2 = mKey2 + b[keyAry[i].trim()];
        }
        if (mKey1 > mKey2) {
          return 1;
        } else {
          return -1;
        }
      });
      mBool = true;
    } catch (e: any) {
      logger.error(e.message, "XXX SortArray Error!");
      mBool = false;
    }
    return mBool;
  }

  /** TagBox 或多選組SQL WHERE */
  //array2Where(xAry: Array<any>, xWhere: string, xField: string): string {
  array2Where(xAry: string[], xWhere: string, xField: string): string {
    //debugger
    if (!xAry) {
      return xWhere;
    }
    let mRet: string = "";
    if (xAry === undefined) {
      return xWhere;
    }
    for (let i = 0; i < xAry.length; i++) {
      if (mRet === "") {
        mRet = "N" + this.quotedStr(xAry[i]);
      } else {
        mRet = mRet + ",N" + this.quotedStr(xAry[i]);
      }
    }
    if (mRet.length > 0) {
      return xWhere + " AND " + xField + " IN ( " + mRet + " )";
    } else {
      return xWhere;
    }
  }
  comma2Where(commaString: string, xWhere: string, xField: string): string {
    if (!commaString) {
      return xWhere;
    }
    if (commaString === "") {
      return xWhere;
    }
    let s: any;
    s = commaString.split(",");
    return this.array2Where(s, xWhere, xField);
  }
  /** xReturnField  */
  grep(source: any[], xCheckField: string, xCheckData: string): any {
    let retData: any[] = [];
    source.forEach((element) => {
      if (element[xCheckField] === xCheckData) {
        retData.push(element);
      }
    });
    return retData;
  }
  grepOne(source: any[], xCheckField: string, xCheckData: string): any {
    let retData: any = {};
    source.forEach((element) => {
      if (element[xCheckField] === xCheckData) {
        retData = element;
      }
    });
    return retData;
  }
  arrayCheckData(
    xTable: Array<any>,
    xCheckField: string,
    xCheckData: string,
    xReturnField: string,
    isShowMessage: boolean
  ): jkRestReturn {
    let mReturn: jkRestReturn = new jkRestReturnClass(); //  {      result: false, data: '', message: '', obj: {}, rowAffected:0    };
    if (xTable === null) {
      mReturn.result = false;
      mReturn.message = "table is null";
    } else {
      if (xCheckData === "") {
        mReturn.result = true;
        mReturn.message = "";
        mReturn.data = "";
      } else {
        let result = this.grep(xTable, xCheckField, xCheckData);
        mReturn.rowsAffected = result.length;
        if (result.length === 1) {
          mReturn.result = true;
          mReturn.data = result[0][xReturnField];
          mReturn.obj = result[0];
        } else {
          if (result.length > 1) {
            let msg = "XXX 找到多於一筆.代號:" + xCheckData;
            if (isShowMessage) {
              logger.error(msg);
            }
            mReturn.data = result[0][xReturnField];
            mReturn.obj = result[0];
            mReturn.message = msg;
          } else {
            if (isShowMessage) {
              mReturn.result = false;
            }
          }
        }
      }
    }

    return mReturn;
  }

  Copy(mStr: string, i: number, xLength: number): string {
    if (mStr === undefined) {
      return "";
    } else {
      // return mStr.substring(i - 1, xLength);
      return mStr.substring(i - 1, i - 1 + xLength); // jackie 20220913 modi
    }
  }

  zeroAtFirst(s: number, iDigit: number): string {
    let mStr = "000000000000000" + s.toString();
    //let s2 = mStr.substring(mStr.length - iDigit, iDigit);
    let s2 = mStr.substring(mStr.length - iDigit, mStr.length);
    return s2;
  }
  Inc(n: any) {
    n = n + 1;
  }
  inc(n: any) {
    this.Inc(n);
  }

  strToIntDef(str: string, def1: number): number {
    let parsed = parseInt(str, 10);
    if (isNaN(parsed)) {
      return def1;
    } else return parsed;
  }
  date2Display(date: any, sep: string): string {
    if (typeof date === "string") {
      return date.substring(0, 10);
    } else if (typeof date === "object") {
      return (
        this.zeroAtFirst(date.getFullYear(), 4) +
        sep +
        this.zeroAtFirst(date.getMonth(), 2) +
        this.zeroAtFirst(date.getDate(), 2)
      );
    } else {
      return "日期格式錯誤";
    }
  }
  time2Display5(date: Date): string {
    return (
      this.zeroAtFirst(date.getHours(), 2) +
      ":" +
      this.zeroAtFirst(date.getMinutes(), 2)
    );
  }
  time2Display8(date: Date): string {
    return (
      this.zeroAtFirst(date.getHours(), 2) +
      ":" +
      this.zeroAtFirst(date.getMinutes(), 2) +
      ":" +
      this.zeroAtFirst(date.getSeconds(), 2)
    );
  }

  getSqlParamsName(sqlSelect: string): string[] {
    let ary: string[] = [];
    let field: any[];
    let temp: any[];
    if (sqlSelect.indexOf(":") > 0) {
      sqlSelect = this.swapStr(sqlSelect, ",", " ");
      sqlSelect = this.swapStr(sqlSelect, "\r\n", " ");
      sqlSelect = this.swapStr(sqlSelect, ")", "");
      while (sqlSelect !== "") {
        temp = this.cutToken2Ary(sqlSelect, ":");
        sqlSelect = temp[1];
        field = this.cutToken2Ary(sqlSelect, " ");
        if (field[0] !== "") {
          ary.push(field[0]);
        }
        sqlSelect = field[1];
      }
    } else {
      sqlSelect = this.swapStr(sqlSelect, ",", " ");
      sqlSelect = this.swapStr(sqlSelect, ")", "");
      while (sqlSelect !== "") {
        temp = this.cutToken2Ary(sqlSelect, "@");
        sqlSelect = temp[1];
        field = this.cutToken2Ary(sqlSelect, " ");
        if (field[0] !== "") {
          ary.push(field[0]);
        }
        sqlSelect = field[1];
      }
    }
    return ary;
  }

  prepareSQL(
    sqlSelect: string,
    params: any[],
    sysDBName: string,
    dbname: string
  ): string {
    let retStr: string = "";
    retStr = sqlSelect;
    let mi: number = 0;
    let j: number = 0;
    while (true) {
      j = retStr.indexOf("##", mi);
      if (j > 0) {
        retStr = retStr.replace("##", sysDBName + "..");
      } else {
        break;
      }
    }
    sqlSelect = retStr;

    while (true) {
      j = retStr.indexOf("$$", mi);
      if (j > 0) {
        retStr = retStr.replace("$$", dbname + "..");
      } else {
        break;
      }
    }
    sqlSelect = retStr;

    let ary: string[] = this.getSqlParamsName(sqlSelect);
    retStr = "";
    retStr = sqlSelect;
    if (sqlSelect.indexOf(":") > 0) {
      try {
        for (let i = 0; i < ary.length; i++) {
          if (i >= params.length) continue;  // ^_^ jackie 20250122 add
          if (typeof params[i] === "number") {
            retStr = retStr.replace(":" + ary[i].trim(), String(params[i]));
          } else if (typeof params[i] === "object") {
            retStr = retStr.replace(
              ":" + ary[i].trim(),
              "'" + JSON.stringify(params[i]) + "'"
            );
          } else if (typeof params[i] === "string") {
            retStr = retStr.replace(":" + ary[i].trim(), "'" + params[i] + "'");
          } else if (typeof params[i] === "boolean") {
            if (params[i]) {
              retStr = retStr.replace(":" + ary[i].trim(), "'Y'");
            } else {
              retStr = retStr.replace(":" + ary[i].trim(), "'N'");
            }
          } else if (typeof params[i] === "undefined") {
            retStr = retStr.replace(":" + ary[i].trim(), "''");
          }
        }
      } catch (e: any) {
        logger.error("inside prepareSQL:", e);
      }
    } else {
      try {
        for (let i = 0; i < ary.length; i++) {
          if (typeof params[i] === "number") {
            retStr = retStr.replace("@" + ary[i].trim(), String(params[i]));
          } else if (typeof params[i] === "object") {
            retStr = retStr.replace(
              "@" + ary[i].trim(),
              "'" + JSON.stringify(params[i]) + "'"
            );
          } else if (typeof params[i] === "string") {
            retStr = retStr.replace("@" + ary[i].trim(), "'" + params[i] + "'");
          } else if (typeof params[i] === "boolean") {
            if (params[i]) {
              retStr = retStr.replace("@" + ary[i].trim(), this.quotedStr("Y"));
            } else {
              retStr = retStr.replace("@" + ary[i].trim(), this.quotedStr("N"));
            }
          } else if (typeof params[i] === "undefined") {
            retStr = retStr.replace("@" + ary[i].trim(), this.quotedStr(""));
          }
        }
      } catch (e: any) {
        logger.error("inside prepareSQL:", e);
      }
    }

    return retStr;
  }
  reBuildSQL(
    xValue: string,
    xCompanyID: string,
    xUserID: string,
    xNowDate: string,
    xUserGroup: string
  ): string {
    // 重組 SQL
    let mStr = "",
      mStr1 = "",
      mCommand = "",
      mTableName = "";

    let result = this.trim(xValue);
    return result;
    // FIXME: 未完成
    /*
      mCommand = xValue.trim();
      mCommand = this.cutToken(mCommand, ' '); // 取第一個指令

      if AnsiPos('UPDATE', UpperCase(mCommand)) > 0 then // Update SQL
      begin
        mStr = CutToken(result, ' SET ');
        if result = '' then
        begin
          result = Trim(xValue);
          mStr = CutToken(result, ' set ');
        end;
        if result = '' then
        begin
          result = Trim(xValue);
          mStr = CutToken(result, ' Set ');
        end;
        // Result = SwapStrCaseSense(Result,' set ',' SET '); // 防呆 ^_^ jackie 1010525     add

        // mTableName=Trim(GetToken(mStr,' ',2));
        mStr1 = mStr;
        mTableName = Trim(CutToken(mStr1, ' ')); // 1125 ^_^ 960604 modi
        mTableName = mStr1;
        result = mStr +
          Format(' SET COMPANY=''%s'', MODIFIER=''%s'', MODI_DATE=''%s'', ',
          [Copy(xCompanyID, 1, 10), Copy(xUserID, 1, 10), xNowDate, mTableName]) +
          ' FLAG=(convert(int,' + mTableName + '.FLAG))%999+1,' + result;

      end
      else // Insert SQL
      begin
        mStr = CutToken(result, ')');
        mStr = mStr + ',COMPANY,CREATOR,USR_GROUP,CREATE_DATE,FLAG)';
        if AnsiPos('FROM', result) <> 0 then // 有 subSql
        begin
          mStr1 = CutToken(result, 'FROM');
          mStr1 = mStr1 + Format(',''%s'',''%s'',''%s'',''%s'',1 FROM ',
            [Copy(xCompanyID, 1, 10), xUserID, xUserGroup, xNowDate]);
        end
        else
        begin
          mStr1 = CutToken(result, ')');
          { mStr1= mStr1+Format(',''%s'',''%s'',SUBSTRING(cast( sysdatetime() as CHAR),12,8),''%s'',1)',
            [xCompanyID,
            xUserID,
            xNowDate]); }
          mStr1 = mStr1 + Format(',''%s'',''%s'',''%s'',''%s'',1)',
            [Copy(xCompanyID, 1, 10), xUserID, xUserGroup, xNowDate]);
        end;
        result = mStr + mStr1 + result;
      end;
    end;
  */
  }
  // dateTime begin
  date8toDate10(date1: string, sep: string): string {
    return (
      date1.substring(0, 4) +
      sep +
      date1.substring(4, 4 + 2) +
      sep +
      date1.substring(6, 6 + 2)
    );
  }
  isoDate2Date(date: string): Date {
    let dt = new Date(date);
    return dt;
  }
  isoDate2Time4(date: string): string {
    // date: iso8601 format return: hhnn
    let dt = new Date(date);
    let s: string =
      this.zeroAtFirst(dt.getHours(), 2) + this.zeroAtFirst(dt.getMinutes(), 2);
    return s;
  }
  isoDate2Time8(date: string): string {
    // date: iso8601 format return hh:nn:ss
    let dt = new Date(date);
    let s: string =
      this.zeroAtFirst(dt.getHours(), 2) +
      ":" +
      this.zeroAtFirst(dt.getMinutes(), 2) +
      ":" +
      this.zeroAtFirst(dt.getSeconds(), 2);
    return s;
  }
  // 2023-01-01T09:00:00+08:00,or 2023-01-01T09:00:00Z
  isoDatetime2LocalDatetime(isoString: string): string {
    let date = new Date(Date.parse(isoString));
    // Output the local time
    return date.toLocaleString(); // Outputs: "12/12/2022, 9:00:00 上午"
  }
  date2Time8(dt: Date | undefined): string {
    // date: iso8601 format return hh:nn:ss
    //let dt = new Date(date)
    let s = "";
    if (dt) {
      try {
        s =
          this.zeroAtFirst(dt.getHours(), 2) +
          ":" +
          this.zeroAtFirst(dt.getMinutes(), 2) +
          ":" +
          this.zeroAtFirst(dt.getSeconds(), 2);
      } catch (error: any) {
        logger.error("date2Time8 error." + error.message);
      }
      return s;
    } else {
      return "";
    }
  }
  isoDate2DateField(iso: string): string {
    let mDate: string = "";
    try {
      let dt = new Date(iso);
      //mDate = formatDate(dt,'YYYYMMDD')
      mDate = this.date2DateField(dt);
    } catch (error: any) {
      mDate = "";
    }
    return mDate;
  }
  jsDateTime2SqlDateTime(datetime: string): string {
    return datetime.substring(0, 23) + "Z";
  }
  date2Timestamp(xDate: string): number {
    if (xDate === "") return 0;
    //let ts : number =Date.parse(xDate)/1000;
    let year = Number(xDate.substring(0, 4));
    let month: number = Number(xDate.substring(4, 4 + 2));
    let day: number = Number(xDate.substring(6, 6 + 2));
    const datum = new Date(Date.UTC(year, month - 1, day, 0, 0, 0));
    let ts = datum.getTime() / 1000;
    return ts;
  }
  timeStamp2Date(x: number): string {
    // multiplied by 1000 so that the argument is in milliseconds, not seconds.
    const date = new Date(x * 1000);
    // Hours part from the timestamp
    /*let hours = date.getHours();
    // Minutes part from the timestamp
    let minutes = date.getMinutes();
    // Seconds part from the timestamp
    let seconds = date.getSeconds();*/
    const yy = date.getFullYear();
    const mm = date.getMonth() + 1;
    const dd = date.getDate();
    // .getDay() 星期
    let date1: string;
    date1 =
      this.zeroAtFirst(yy, 4) +
      this.zeroAtFirst(mm, 2) +
      this.zeroAtFirst(dd, 2);
    return date1;
  }
  timeStamp2Time4(x: number): string {
    // multiplied by 1000 so that the argument is in milliseconds, not seconds.
    const date = new Date(x * 1000);
    // Hours part from the timestamp
    const hours = date.getHours();
    // Minutes part from the timestamp
    const minutes = date.getMinutes();
    // Seconds part from the timestamp
    const seconds = date.getSeconds();
    let time4: string;
    time4 = this.zeroAtFirst(hours, 2) + this.zeroAtFirst(minutes, 2);
    return time4;
  }
  YYYYMMDD2ROC(xStr: string, xSep: string): string {
    let Result = "";
    if (xStr.length === 8) {
      try {
        Result =
          this.intToStr(this.StrToInt(this.Copy(xStr, 1, 4)) - 1911) +
          xSep +
          this.Copy(xStr, 5, 2) +
          xSep +
          this.Copy(xStr, 7, 2);
      } catch ($e) {
        Result = "";
      }
      return Result;
    } else {
      return Result;
    }
  }

  ROC2YYYYMM(xStr: string): string {
    let Result = "";
    if (xStr.length === 5) {
      try {
        Result =
          this.intToStr(this.strToInt(this.Copy(xStr, 1, 3)) + 1911) +
          this.Copy(xStr, 4, 2);
      } catch ($e) {
        Result = "";
      }
    } else if (xStr.length === 6) {
      try {
        Result =
          this.intToStr(this.strToInt(this.Copy(xStr, 1, 3)) + 1911) +
          this.Copy(xStr, 5, 2);
      } catch ($e) {
        Result = "";
      }
    } else {
      Result = xStr;
    }
    return Result;
  }
  ROC2YYYY(xStr: string): string {
    let Result = "";
    if (xStr.length === 3) {
      try {
        Result = this.intToStr(this.strToInt(this.Copy(xStr, 1, 3)) + 1911);
      } catch ($e) {
        Result = "";
      }
    } else {
      Result = xStr;
    }
    return Result;
  }
  ROC2YYYYMMDD(xStr: string): string {
    let Result = "";
    if (xStr.length === 9 && this.pos("/", xStr) > 0) {
      try {
        Result =
          this.intToStr(this.strToInt(this.Copy(xStr, 1, 3)) + 1911) +
          this.Copy(xStr, 5, 2) +
          this.Copy(xStr, 8, 2);
      } catch ($e) {
        Result = "";
      }
      return Result;
    }
    if (xStr.length === 8 && this.pos("/", xStr) > 0) {
      try {
        Result =
          this.intToStr(this.strToInt(this.Copy(xStr, 1, 2)) + 1911) +
          this.Copy(xStr, 4, 2) +
          this.Copy(xStr, 7, 2);
      } catch ($e) {
        Result = "";
      }
      return Result;
    }
    if (xStr.length === 7) {
      try {
        Result =
          this.intToStr(this.strToInt(this.Copy(xStr, 1, 3)) + 1911) +
          this.Copy(xStr, 4, 4);
      } catch ($e) {
        Result = "";
      }
    } else {
      Result = xStr;
    }
    return Result;
  }
  time5toTime4(s: string): string {
    return s.substring(0, 2) + s.substring(3, 5);
  }
  beginTime(): Date {
    this.dtBegin = new Date();
    return this.dtBegin;
  }
  // 20210723 add
  countTimeMicroSecond(): number {
    return this.microSecondDiff(new Date(), this.dtBegin);
  }
  endTime(): number {
    // 同countTime
    //return this.countTime();
    return this.secondDiff(new Date(), this.dtBegin);
  }
  beginLogTime() {
    this.logTime = new Date();
  }
  endLogTime(): number {
    return this.secondDiff(this.logTime, new Date());
  }

  dateDiff(startTime: string, endTime: string, diffType: string): number {
    //將xxxx-xx-xx的時間格式，轉換為 xxxx/xx/xx的格式
    startTime = startTime.replace(/\-/g, "/");

    endTime = endTime.replace(/\-/g, "/");
    //將計算間隔類性字符轉換為小寫
    diffType = diffType.toLowerCase();
    const sTime: Date = new Date(startTime); //開始時間
    const eTime: Date = new Date(endTime); //結束時間

    //作為除數的數字
    let timeType = 1;
    switch (diffType) {
      case "second":
        timeType = 1000;
        break;
      case "minute":
        timeType = 1000 * 60;
        break;
      case "hour":
        timeType = 1000 * 3600;
        break;
      case "day":
        timeType = 1000 * 3600 * 24;
        break;
      default:
        break;
    }
    return (eTime.getTime() - sTime.getTime()) / timeType;
  }
  secondDiff(dt2: Date, dt1: Date): number {
    const diff = (dt2.getTime() - dt1.getTime()) / 1000;
    return Math.abs(Math.round(diff));
  }
  microSecondDiff(dt2: Date, dt1: Date): number {
    let diff = dt2.getTime() - dt1.getTime();
    return Math.abs(Math.round(diff));
  }
  minuteDiff(dt2: Date, dt1: Date): number {
    let diff = (dt2.getTime() - dt1.getTime()) / 1000;
    diff /= 60;
    return Math.abs(Math.round(diff));
  }
  timeStamp(): number {
    const dateTime: number = new Date().getTime();
    const timestamp: number = Math.floor(dateTime / 1000);
    return timestamp;
  }
  timeStamp13(): number {
    // also 可以當13碼序號 #sn #serialno
    let n = Date.now();
    return n;
  }
  /**
   * 計算給定日期的星期幾
   * @param mdt 日期
   * @returns 星期幾 (1~7，週日~週六)
   */
  dayOfWeek(mdt: Date): number {
    const day = mdt.getDay(); // 0~6, 週日~週六
    return day === 0 ? 7 : day; // 將 0 (週日) 轉換為 7
  }

  day2Week(xDate: string, xDateKind: number): string {
    if (xDate === "" || xDate === undefined) {
      return "";
    }
    let n: number = 7;
    try {
      const d = this.TransDateIn(xDate);
      if (!d) return "";
      n = d.getDay();
    } catch (e: any) { }
    let week;
    if (xDateKind > 3) {
      week = ["日", "一", "二", "三", "四", "五", "六", ""];
    } else {
      week = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT", ""];
    }
    return week[n];
  }
  getTime(): string {
    const date: Date = new Date();
    return (
      date.getHours() +
      ":" +
      date.getMinutes() +
      ":" +
      date.getSeconds() +
      ":" +
      date.getMilliseconds()
    );
  }

  dateField2Display(date1: string): string {
    if (!date1) return date1;
    let mStr = "";
    try {
      if (date1 !== undefined) {
        mStr =
          date1.substring(0, 4) +
          "/" +
          date1.substring(4, 4 + 2) +
          "/" +
          date1.substring(6, 6 + 2);
      }

    } catch (error: any) {
      console.error('dateField2Display:', error.message);
    }
    return mStr;
  }
  // 定義日期格式化函數
  datetimeFormatter(value: any): string {
    const date = new Date(value);
    return date.toLocaleString(); // 使用當地日期時間格式
  }

  htmlStatusCode(n: number): string {
    let s = "";
    switch (n) {
      case 200:
        s = "請求已成功,OK";
        break;
      case 201:
        s = "請求已經被實現,Created";
        break;
      case 202:
        s = "伺服器已接受請求，但尚未處理。Accepted";
        break;
      case 203:
        s = "伺服器是一個轉換代理伺服器,Non-Authoritative Information";
        break;
      case 204:
        s = "伺服器成功處理了請求，沒有返回任何內容。No Content";
        break;
      case 205:
        s = "伺服器成功處理了請求，但沒有返回任何內容。Reset Content";
        break;
      case 206:
        s = "伺服器已經成功處理了部分GET請求。Partial Content";
        break;
      case 207:
        s =
          "之後的訊息體將是一個XML訊息，並且可能依照之前子請求數量的不同，包含一系列獨立的回應代碼。Multi-Status";
        break;
      case 300:
        s =
          "被請求的資源有一系列可供選擇的回饋資訊，每個都有自己特定的位址和瀏覽器驅動的商議資訊。Multiple Choices";
        break;
      case 301:
        s =
          "被請求的資源已永久移動到新位置，並且將來任何對此資源的參照都應該使用本回應返回的若干個URI之一。Moved Permanently";
        break;
      case 302:
        s =
          "要求客戶端執行臨時重新導向（原始描述短語為「Moved Temporarily」）。Found";
        break;
      case 303:
        s =
          "對應當前請求的回應可以在另一個URI上被找到，當回應於POST（或PUT / DELETE）接收到回應時，客戶端應該假定伺服器已經收到資料，並且應該使用單獨的GET訊息發出重新導向。See Other";
        break;
      case 304:
        s =
          "表示資源在由請求頭中的If-Modified-Since或If-None-Match參數指定的這一版本之後，未曾被修改。Not Modified";
        break;
      case 305:
        s = "被請求的資源必須通過指定的代理才能被存取。Use Proxy";
        break;
      case 306:
        s = "已經被廢棄的HTTP/1.0規範中的代碼，目前已不再被使用。";
        break;
      case 307:
        s =
          "在這種情況下，請求應該與另一個URI重複，但後續的請求應仍使用原始的URI。Temporary Redirect";
        break;
      case 308:
        s =
          "代表請求的資源現在有一個不同的URI，應使用回應中的Location標頭所指定的URI重新導向。Permanent Redirect";
        break;
      case 400:
        s =
          "由於明顯的客戶端錯誤（例如，格式錯誤的請求語法，太大的大小，無效的請求訊息或欺騙性路由請求），伺服器不能或不會處理該請求。Bad Request";
        break;
      case 401:
        s = "未認證。Unauthorized";
        break;
      case 402:
        s = "該狀態碼是為了將來可能的需求而預留的。Payment Required";
        break;
      case 403:
        s = "伺服器已經理解請求，但是拒絕執行它。Forbidden";
        break;
      case 404:
        s =
          "請求失敗，請求所希望得到的資源未被在伺服器上發現，但允許使用者的後續請求。Not Found";
        break;
      case 405:
        s =
          "請求行中指定的請求方法不能被用於請求相應的資源。Method Not Allowed";
        break;
      case 406:
        s =
          "請求的資源的內容特性無法滿足請求頭中的條件，因而無法生成回應實體，該請求不可接受。Not Acceptable";
        break;
      case 407:
        s =
          "與401回應類似，只不過客戶端必須在代理伺服器上進行身分驗證。Proxy Authentication Required";
        break;
      case 408:
        s = "請求逾時。Request Timeout";
        break;
      case 409:
        s =
          "表示因為請求存在衝突無法處理該請求，例如多個同步更新之間的編輯衝突。Conflict";
        break;
      case 410:
        s = "表示所請求的資源不再可用。Gone";
        break;
      case 411:
        s =
          "伺服器拒絕在沒有定義Content-Length頭的情況下接受請求。Length Required";
        break;
      case 412:
        s =
          "伺服器在驗證在請求的頭欄位中給出先決條件時，沒能滿足其中的一個或多個。Precondition Failed";
        break;
      case 413:
        s =
          "前稱「Request Entity Too Large」，表示伺服器拒絕處理當前請求，因為該請求提交的實體資料大小超過了伺服器願意或者能夠處理的範圍。Request Entity Too Large";
        break;
      case 414:
        s =
          "前稱「Request-URI Too Long」，[42]表示請求的URI長度超過了伺服器能夠解釋的長度，因此伺服器拒絕對該請求提供服務。Request-URI Too Long";
        break;
      case 415:
        s =
          "對於當前請求的方法和所請求的資源，請求中提交的網際網路媒體類型並不是伺服器中所支援的格式，因此請求被拒絕。Unsupported Media Type";
        break;
      case 416:
        s =
          "客戶端已經要求檔案的一部分（Byte serving），但伺服器不能提供該部分。Requested Range Not Satisfiable";
        break;
      case 417:
        s =
          "在請求頭Expect中指定的預期內容無法被伺服器滿足。Expectation Failed";
        break;
      case 429:
        s = "用戶在給定的時間內發送了太多的請求（“限流”）。Too Many Requests";
        break;
      case 500:
        s =
          "通用錯誤訊息，伺服器遇到了一個未曾預料的狀況，導致了它無法完成對請求的處理。Internal Server Error";
        break;
      case 501:
        s = "伺服器不支援當前請求所需要的某個功能。Not Implemented";
        break;
      case 502:
        s =
          "作為閘道器或者代理工作的伺服器嘗試執行請求時，從上游伺服器接收到無效的回應。Bad Gateway";
        break;
      case 503:
        s =
          "由於臨時的伺服器維護或者過載，伺服器當前無法處理請求。Service Unavailable";
        break;
      case 504:
        s =
          "作為閘道器或者代理工作的伺服器嘗試執行請求時，未能及時從上游伺服器（URI標識出的伺服器，例如HTTP、FTP、LDAP）或者輔助伺服器（例如DNS）收到回應。Gateway Timeout";
        break;
      case 505:
        s =
          "伺服器不支援，或者拒絕支援在請求中使用的HTTP版本。HTTP Version Not Supported";
        break;
      default:
        s = "狀態碼:" + n.toString() + ",未知(Unknown)";
        break;
    }
    return s;
  }
  IdNameItemConvert(xIds: string, xIncludeId: boolean): string {
    let mStr: string;
    let mJson: string;
    let mName: string;
    let mId: string;
    let result = "";

    mStr = this.trim(xIds);
    mStr = this.swapStr(mStr, "、", " ");
    mStr = this.swapStr(mStr, ":", ".");
    mStr = this.swapStr(mStr, ",", " ");
    mJson = "";
    while (mStr !== "") {
      let cut;
      cut = this.cutToken(mStr, " ");
      mName = this.trim(cut[0]);
      mStr = cut[1];
      mStr = this.trim(mStr);
      cut = this.cutToken(mName, ".");

      mId = this.trim(cut[0]);
      mName = this.trim(cut[1]);

      mJson =
        mJson +
        this.iif(mJson === "", "", ",") +
        '{ id:"' +
        mId +
        '" , name:"' +
        this.iif(xIncludeId, mId + ":" + mName, mName) +
        '" }';
    }
    mJson = " [ " + mJson + " ] ";
    result = mJson;
    return result;
  }
  //keyValueJoin(item: object, keyFieldList: string[]): string {
  //keyValueJoin(item: { [key: string]: any }, keyFieldList: string[]): string {
  keyValueJoin(item: any, keyFieldList: string[]): string {
    let keyValueJoin = "";
    for (let i = 0; i < keyFieldList.length; i++) {
      let s: any = keyFieldList[i];
      keyValueJoin += item[s].trim();
    }
    return keyValueJoin;
  }
  //keyValue2SqlWhere(item: object, opt: keyValue2SqlWhereOption): boolean {
  keyValue2SqlWhere(item: any, opt: keyValue2SqlWhereOption): boolean {
    let result = true;
    opt.params = [];
    opt.where = "";
    for (let i = 0; i < opt.keyFieldList.length; i++) {
      opt.where =
        opt.where + " AND (" + opt.keyFieldList[i] + "=@" + String(i) + ") "; // this.keyFieldList[i];
    }
    for (let j = 0; j < opt.keyFieldList.length; j++) {
      opt.params.push(item[opt.keyFieldList[j]]);
    }
    return result;
    // 接下來做       await jkOrm.runSqlParams(this.sqlDelete, params, ret);
  }

  objectArray2String(
    xRetField: string,
    xAry: Array<any>,
    xHeadStr: string
  ): string {
    //debugger
    if (!xAry) {
      return xHeadStr;
    }
    let mRet: string = "";
    if (xAry === undefined) {
      return xHeadStr;
    }
    for (let i = 0; i < xAry.length; i++) {
      if (xAry[i][xRetField] === undefined) continue;
      if (mRet === "") {
        mRet = this.fixString(xAry[i][xRetField]);
      } else {
        mRet = mRet + "," + this.fixString(xAry[i][xRetField]);
      }
    }
    if (mRet.length > 0) {
      return xHeadStr + "," + mRet;
    } else {
      return xHeadStr;
    }
  }
  compare2Sql(
    xCompare: string,
    fieldId: string,
    dataType: string,
    value: string
  ): string {
    let ret = '';
    let compare = xCompare;
    let compareStr = compare;
    if (compare === '%like') {
      compareStr = ' like ';
      value = "'%" + value + "'";
      ret = ' (' + fieldId + compareStr + value + ') ';
    } else if (compare === '%like%') {
      compareStr = ' like ';
      value = "'%" + value + "%'";
      ret = ' (' + fieldId + compareStr + value + ') ';
    } else if (compare === 'like%') {
      compareStr = ' like ';
      value = "'" + value + "%'";
      ret = ' (' + fieldId + compareStr + value + ') ';
    } else {
      if (dataType === 'string' || dataType === 'text') {
        value = "'" + value + "'";
      }
      ret = ' (' + fieldId + ' ' + compareStr + ' ' + value + ') ';
    }
    return ret;
  };
  normalizeUrl(u: string): string {
    if (!u) return '';
    // 若未帶協定，補 http:// 以利 URL 解析
    if (!/^[a-zA-Z][a-zA-Z0-9+.-]*:\/\//.test(u)) {
      return 'http://' + u;
    }
    return u;
  }

  parseUrl(raw: string): {
    ok: boolean;
    origin: string;
    hostWithProtocol: string; // same as origin
    path: string;
    query: Record<string, string>;
    rawQuery: string;
    error?: any;
  } {
    if (!raw)
      return {
        ok: false,
        origin: '',
        hostWithProtocol: '',
        path: '',
        query: {},
        rawQuery: '',
      };
    const n = this.normalizeUrl(raw);
    try {
      const u = new URL(n);
      const qMap: Record<string, string[]> = {};
      u.searchParams.forEach((v, k) => {
        if (!qMap[k]) qMap[k] = [];
        qMap[k].push(v);
      });
      const merged: Record<string, string> = {};
      Object.keys(qMap).forEach((k) => {
        merged[k] = qMap[k].map((s) => decodeURIComponent(s)).join('||'); // 多值合併
      });
      return {
        ok: true,
        origin: u.origin,
        hostWithProtocol: u.origin,
        path: u.pathname || '/',
        query: merged,
        rawQuery: u.search ? u.search.substring(1) : '',
      };
    } catch (err) {
      return {
        ok: false,
        origin: '',
        hostWithProtocol: '',
        path: '',
        query: {},
        rawQuery: '',
        error: err,
      };
    }
  }


}

export let jkBaseLib = new jkBaseLibClass();
//-----------------------
export class openWinClass implements IopenWin {
  //  implements openWin  extends jkComm
  result: boolean = false;
  mainTable: string = "";
  item: string = "";
  type: string = "";
  title: string = "";
  sqlSelect: string = "";
  where: string = "";
  sqlOrder: string = "";
  order: string = "";// 需有 order by,getOpenWinLoadOption會自動補上
  // orderBy: string = "";
  PS: string = "";
  display: string = "";
  map: string = "";
  sqlReturn: string = "";
  message: string = "";
  valueExpr: string = "";
  displayExpr: string = "";
  obj: any;
  params: any[] = [];
  returnData: any[] = [];
  // rowsAffected: number = 0;
  //sqlRet: any; // this.jkRestReturn;
  constructor() {
    this.clear();
  }
  clear(result: boolean = false): void {
    this.result = result;
    this.mainTable = "";
    this.item = "";
    this.type = "";
    //this.rowsAffected = 0;
    this.title = "";
    this.sqlSelect = "";
    this.where = "";
    this.order = "";
    //this.orderBy = "";
    this.PS = "";
    this.display = "";
    this.map = "";
    this.sqlReturn = "";
    this.message = "";
    this.returnData = [];
    this.params = [];
  }
  checkOrderBy(s: string): string {
    if ((s !== '') && (s.toLowerCase().indexOf('order by') < 0)) {
      s = ' /*ORDER*/ ORDER BY ' + s;
    }
    return s;
  }
  getOpenWinLoadOption(host: string = '', token: string = ''): OpenWinLoadOption {
    let order = this.checkOrderBy(this.order);
    let opt: OpenWinLoadOption = {
      mainTable: this.mainTable,
      item: this.item,
      type: this.type,
      where: this.where,
      order: order,
      params: this.params,
      host: host,
      token: token,
      list: this.returnData
    }
    return opt;
  }
  assign(ow: IopenWin): boolean {
    let result = false;
    this.result = ow.result;
    /*if (!this.result) {
      alert('');
      return false;
    }*/
    this.mainTable = ow.mainTable;
    this.item = ow.item;
    this.type = ow.type;
    this.title = ow.title;
    this.sqlSelect = ow.sqlSelect;
    this.where = ow.where;
    this.order = ow.order;
    if (ow.order.toLowerCase().indexOf('order by') >= 0) {
      this.order = ow.order;
    } else {
      this.order = '/*ORDER*/ ORDER BY ' + ow.order;
    }

    this.PS = ow.PS;
    this.display = ow.display;
    this.map = ow.map;
    this.sqlReturn = ow.sqlReturn;
    result = true;
    return result;
  }
  makeSqlSelect(): string {
    let sql = this.sqlSelect;
    this.where = jkBaseLib.fixString(this.where);
    this.order = jkBaseLib.fixString(this.order);
    if (sql.indexOf("/*WHERE*/") > 0) {
      sql = jkBaseLib.replaceLine(sql, "/*WHERE*/", this.where);
    } else {
      sql = sql + " /*WHERE*/ WHERE 1=1 " + this.where;
    }
    if (this.order !== "") {
      if (sql.indexOf("/*ORDER*/") > 0) {
        sql = jkBaseLib.replaceLine(sql, "/*ORDER*/", this.order);
      } else {
        sql = sql + " /*ORDER*/ " + this.order;
      }
    }
    return sql;
  }

}

export class kbarClass implements kbar {
  open: number;
  high: number;
  low: number;
  close: number;
  volume: number;
  date: Date;
  dir: number;
  constructor() {
    this.open = 0;
    this.high = 0;
    this.low = 0;
    this.close = 0;
    this.volume = 0;
    this.date = new Date();
    this.dir = 0;
  }
  assign(
    open: number,
    high: number,
    low: number,
    close: number,
    volume: number,
    date: Date
  ) {
    this.open = open;
    this.high = high;
    this.low = low;
    this.close = close;
    this.volume = volume;
    this.date = date;
    if (open === close) {
      this.dir = 0;
    } else if (open < close) {
      this.dir = 1;
    } else {
      this.dir = -1;
    }
  }
}

export class SqlOption {
  sqlSelect: string = '';
  sqlWhereDefault: string = ' WHERE 1=1 ';
  sqlOrderDefault: string = '';
  sqlWhere: string = '';
  sqlOrder: string = '';
  sqlGroupBy: string = '';
  param: any[] = [];
  isSys: boolean = false;
  makeSql(): string {
    let sql =
      this.sqlSelect +
      CR + this.sqlWhereDefault + ' ' +
      this.sqlWhere +
      CR + ' ' +
      this.sqlGroupBy +
      CR +
      this.sqlOrder;
    return sql;
  }
}

export class CustomDateAdapter extends NativeDateAdapter {
  override format(date: Date, displayFormat: Object): string {
    let day = date.getDate();
    let month = date.getMonth() + 1;
    let year = date.getFullYear();

    return `${year}/${this.pad(month)}/${this.pad(day)}`;
  }

  private pad(n: number): string {
    return ('00' + n).slice(-2);
  }
}

